let aiWidgetInitialized = false
let aiWidgetVisible = true

// Simple markdown parser
const parseMarkdown = (text) => {
  if (!text) return ''

  return (
    text
      // Handle literal \n strings first
      .replace(/\\n/g, '<br>')
      // Handle actual line breaks
      .replace(/\n/g, '<br>')
      // Bold text
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      // Italic text
      .replace(/\*(.*?)\*/g, '<em>$1</em>')
      // Code blocks
      .replace(
        /```([\s\S]*?)```/g,
        '<pre style="background: #f3f4f6; padding: 8px; border-radius: 4px; font-family: monospace; font-size: 12px; overflow-x: auto; margin: 8px 0;"><code>$1</code></pre>'
      )
      // Inline code
      .replace(
        /`([^`]+)`/g,
        '<code style="background: #f3f4f6; padding: 2px 4px; border-radius: 3px; font-family: monospace; font-size: 12px;">$1</code>'
      )
      // Headers
      .replace(
        /^### (.*$)/gm,
        '<h3 style="font-size: 16px; font-weight: 600; margin: 12px 0 8px 0; color: #374151;">$1</h3>'
      )
      .replace(
        /^## (.*$)/gm,
        '<h2 style="font-size: 18px; font-weight: 600; margin: 16px 0 8px 0; color: #374151;">$1</h2>'
      )
      .replace(
        /^# (.*$)/gm,
        '<h1 style="font-size: 20px; font-weight: 600; margin: 20px 0 8px 0; color: #374151;">$1</h1>'
      )
      // Lists
      .replace(/^\* (.*$)/gm, '<li style="margin: 4px 0;">• $1</li>')
      .replace(/^- (.*$)/gm, '<li style="margin: 4px 0;">• $1</li>')
      // Wrap lists in ul tags (simplified)
      .replace(
        /(<li.*?<\/li>)/g,
        '<ul style="margin: 8px 0; padding-left: 16px;">$1</ul>'
      )
      // Links
      .replace(
        /\[([^\]]+)\]\(([^)]+)\)/g,
        '<a href="$2" target="_blank" style="color: rgb(41, 128, 185); text-decoration: underline;">$1</a>'
      )
      // Blockquotes
      .replace(
        /^> (.*$)/gm,
        '<blockquote style="border-left: 4px solid rgb(41, 128, 185); padding-left: 12px; margin: 8px 0; color: #6b7280; font-style: italic;">$1</blockquote>'
      )
  )
}

const createAIAgentWidget = () => {
  // Check if user is authenticated via localStorage
  const auth = localStorage.getItem('auth')
  if (!auth || auth === 'null' || auth === 'undefined' || auth === '') {
    console.log(
      'AI Agent Widget: User not authenticated, skipping initialization'
    )
    return
  }

  // Create the floating button
  const floatingButton = document.createElement('div')
  floatingButton.id = 'ai-agent-widget-button'
  floatingButton.style.cssText = `
    position: fixed !important;
    bottom: 20px !important;
    left: 20px !important;
    width: 60px !important;
    height: 60px !important;
    background: url('https://lux-git-main-erste-hausverwaltung.vercel.app/lux_neu.png') center center / cover !important;
    border-radius: 50% !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
    cursor: pointer !important;
    z-index: 999999 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    border: 2px solid white !important;
    user-select: none !important;
    visibility: visible !important;
    opacity: 1 !important;
  `

  // Add hover effects
  if (floatingButton) {
    floatingButton.onmouseenter = () => {
      floatingButton.style.transform = 'scale(1.1)'
      floatingButton.style.boxShadow = '0 8px 24px rgba(0, 0, 0, 0.5)'
    }
    floatingButton.onmouseleave = () => {
      floatingButton.style.transform = 'scale(1)'
      floatingButton.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.3)'
    }
  }

  // Add pulse animation CSS
  if (!document.querySelector('#ai-widget-styles')) {
    const style = document.createElement('style')
    style.id = 'ai-widget-styles'
    style.textContent = `
      @keyframes ai-pulse {
        0% { opacity: 1; transform: scale(1); }
        50% { opacity: 0.5; transform: scale(1.2); }
        100% { opacity: 1; transform: scale(1); }
      }
      
      @keyframes ai-slide-in {
        from { transform: translateX(-100px); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
      }
      
      @keyframes ai-slide-out {
        from { transform: translateX(0); opacity: 1; }
        to { transform: translateX(-100px); opacity: 0; }
      }
      
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
      
      .ai-chat-container {
        animation: ai-slide-in 0.3s ease-out;
      }
      
      .ai-chat-container.closing {
        animation: ai-slide-out 0.3s ease-in;
      }
    `
    document.head.appendChild(style)
  }

  // Click handler to toggle chat
  if (floatingButton) {
    floatingButton.onclick = () => {
      console.log('AI widget button clicked')
      const existingChat = document.querySelector('#ai-agent-chat')

      if (existingChat && existingChat.style.display !== 'none') {
        // Chat is visible, hide it
        console.log('Hiding existing chat')
        existingChat.classList.add('closing')
        setTimeout(() => {
          existingChat.style.display = 'none'
        }, 300)
      } else {
        // Chat is hidden or doesn't exist, show it
        openAIAgentChat()
        // Remove notification when chat is opened
        if (window.AIWidgetManager) {
          window.AIWidgetManager.removeNotification()
        }
      }
    }
  }

  // Add to page with null check
  if (document.body) {
    document.body.appendChild(floatingButton)
  } else {
    console.error('Document body not found, cannot append AI widget')
  }

  // Auto-hide when scrolling (optional)
  let scrollTimeout
  document.addEventListener('scroll', () => {
    if (scrollTimeout) clearTimeout(scrollTimeout)
    floatingButton.style.opacity = '0.7'
    scrollTimeout = setTimeout(() => {
      floatingButton.style.opacity = '1'
    }, 1000)
  })
}

const openAIAgentChat = () => {
  // Check if chat already exists and just show it
  const existingChat = document.querySelector('#ai-agent-chat')
  if (existingChat) {
    // Remove any closing animation class
    existingChat.classList.remove('closing')
    existingChat.style.display = 'flex'
    existingChat.style.visibility = 'visible'
    existingChat.style.opacity = '1'
    return
  }

  // Create chat container
  const chatContainer = document.createElement('div')
  chatContainer.id = 'ai-agent-chat'
  chatContainer.className = 'ai-chat-container'
  chatContainer.style.cssText = `
    position: fixed;
    bottom: 90px;
    left: 20px;
    width: 450px;
    height: 600px;
    background: white;
    border-radius: 16px;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    z-index: 10001;
    display: flex;
    flex-direction: column;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    border: 1px solid #e5e7eb;
    overflow: hidden;
  `

  // Header
  const header = document.createElement('div')
  header.style.cssText = `
    background: linear-gradient(135deg, rgb(41, 128, 185), rgb(52, 152, 219));
    color: white;
    padding: 16px 20px;
    border-radius: 16px 16px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  `

  const headerTitle = document.createElement('div')
  headerTitle.innerHTML = `
    <div style="font-weight: 600; font-size: 16px;">AI Assistent</div>
    <div style="font-size: 12px; opacity: 0.9; margin-top: 2px;">Online • Bereit zu helfen</div>
  `

  // Create button container for proper alignment
  const buttonContainer = document.createElement('div')
  buttonContainer.style.cssText = `
    display: flex;
    align-items: center;
    gap: 8px;
  `

  // Add reset button
  const resetBtn = document.createElement('button')
  resetBtn.innerHTML = '↺'
  resetBtn.title = 'Chat zurücksetzen'
  resetBtn.style.cssText = `
    background: none;
    border: none;
    color: white;
    font-size: 16px;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    transition: background-color 0.2s;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  `
  resetBtn.onmouseover = () =>
    (resetBtn.style.backgroundColor = 'rgba(255, 255, 255, 0.2)')
  resetBtn.onmouseout = () => (resetBtn.style.backgroundColor = 'transparent')
  resetBtn.onclick = () => {
    // Clear messages area except for welcome message
    const messagesArea = chatContainer.querySelector('div[style*="flex: 1"]')
    if (messagesArea) {
      // Keep only the first message (welcome message)
      const messages = messagesArea.children
      for (let i = messages.length - 1; i > 0; i--) {
        messages[i].remove()
      }
    }
  }

  const closeBtn = document.createElement('button')
  closeBtn.innerHTML = '×'
  closeBtn.style.cssText = `
    background: none;
    border: none;
    color: white;
    font-size: 20px;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    transition: background-color 0.2s;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  `
  closeBtn.onmouseover = () =>
    (closeBtn.style.backgroundColor = 'rgba(255, 255, 255, 0.2)')
  closeBtn.onmouseout = () => (closeBtn.style.backgroundColor = 'transparent')
  closeBtn.onclick = () => {
    chatContainer.classList.add('closing')
    setTimeout(() => {
      // Hide chat instead of removing it
      chatContainer.style.display = 'none'
    }, 300)
  }

  buttonContainer.appendChild(resetBtn)
  buttonContainer.appendChild(closeBtn)

  header.appendChild(headerTitle)
  header.appendChild(buttonContainer)

  // Chat messages area
  const messagesArea = document.createElement('div')
  messagesArea.style.cssText = `
    flex: 1;
    overflow-y: auto;
    padding: 16px;
    background: #f9fafb;
  `

  // Add welcome message
  const welcomeMessage = document.createElement('div')
  welcomeMessage.style.cssText = `
    background: white;
    padding: 12px 16px;
    border-radius: 12px;
    margin-bottom: 12px;
    border-left: 4px solid rgb(41, 128, 185);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  `
  const welcomeText = `Hallo! 👋 Ich bin Ihr AI-Assistent und helfe Ihnen gerne bei Fragen zu **Vorgängen**, **Berichten**, **Kundenkontakten** und mehr. 

Sie können auch **PDF-Dokumente** hochladen, die ich dann direkt analysiere und als Kontext für Ihre Fragen verwende.

**Wie kann ich Ihnen helfen?**`

  welcomeMessage.innerHTML = `
    <div style="font-weight: 500; color: #374151; margin-bottom: 4px; font-size: 14px;">AI Assistent</div>
    <div style="color: #6b7280; font-size: 13px; line-height: 1.4;">
      ${parseMarkdown(welcomeText)}
    </div>
  `
  messagesArea.appendChild(welcomeMessage)

  // Add quick action buttons
  const quickActions = document.createElement('div')
  quickActions.style.cssText = `
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
  `

  const quickActionButtons = [
    {
      text: 'Hilfe',
      action: () =>
        sendQuickMessage('Ich brauche Hilfe bei der Nutzung der Anwendung.'),
    },
  ]

  quickActionButtons.forEach((btn) => {
    const actionBtn = document.createElement('button')
    actionBtn.textContent = btn.text
    actionBtn.style.cssText = `
      padding: 6px 12px;
      background: #f3f4f6;
      border: 1px solid #d1d5db;
      border-radius: 16px;
      font-size: 11px;
      cursor: pointer;
      transition: all 0.2s;
      color: #374151;
    `
    actionBtn.onmouseover = () => {
      actionBtn.style.background = '#e5e7eb'
      actionBtn.style.borderColor = '#9ca3af'
    }
    actionBtn.onmouseout = () => {
      actionBtn.style.background = '#f3f4f6'
      actionBtn.style.borderColor = '#d1d5db'
    }
    actionBtn.onclick = btn.action
    quickActions.appendChild(actionBtn)
  })

  welcomeMessage.appendChild(quickActions)

  // Helper function for quick messages
  const sendQuickMessage = (message) => {
    const input = document.querySelector('#ai-agent-chat textarea')
    if (input) {
      input.value = message
      input.focus()
    }
  }

  // Input area
  const inputArea = document.createElement('div')
  inputArea.style.cssText = `
    padding: 20px;
    background: #fff;
    border-top: 1px solid #e5e7eb;
    border-radius: 0 0 16px 16px;
    box-shadow: 0 2px 8px rgba(41,128,185,0.06);
    display: flex;
    align-items: center;
    gap: 12px;
  `

  const inputContainer = document.createElement('div')
  inputContainer.style.cssText = `
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
  `

  // Add file upload button
  const uploadBtn = document.createElement('button')
  uploadBtn.innerHTML = `
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke="currentColor" stroke-width="2" fill="none"/>
      <polyline points="14,2 14,8 20,8" stroke="currentColor" stroke-width="2" fill="none"/>
      <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" stroke-width="2"/>
      <line x1="12" y1="9" x2="12" y2="17" stroke="currentColor" stroke-width="2"/>
    </svg>
  `

  uploadBtn.style.cssText = `
    width: 44px;
    height: 44px;
    background: #fff;
    border: 1.5px solid #d1d5db;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 1px 3px rgba(41,128,185,0.07);
    cursor: pointer;
    transition: border-color 0.2s, box-shadow 0.2s;
    font-size: 20px;
  `

  uploadBtn.title = 'PDF-Dateien hochladen (Drag & Drop möglich)'
  uploadBtn.onmouseover = () => {
    uploadBtn.style.borderColor = '#2980b9'
    uploadBtn.style.boxShadow = '0 2px 8px rgba(41,128,185,0.12)'
  }
  uploadBtn.onmouseout = () => {
    uploadBtn.style.borderColor = '#d1d5db'
    uploadBtn.style.boxShadow = '0 1px 3px rgba(41,128,185,0.07)'
  }

  // Create hidden file input
  const fileInput = document.createElement('input')
  fileInput.type = 'file'
  fileInput.accept = '.pdf'
  fileInput.style.display = 'none'
  fileInput.multiple = true

  // File upload handler
  const handleFileUpload = (files) => {
    const pdfFiles = Array.from(files).filter(
      (file) => file.type === 'application/pdf'
    )

    if (pdfFiles.length === 0) {
      // Show error message
      const errorMsg = document.createElement('div')
      errorMsg.style.cssText = `
        background: #fef2f2;
        color: #dc2626;
        padding: 8px 12px;
        border-radius: 8px;
        margin-bottom: 8px;
        font-size: 12px;
        border-left: 3px solid #dc2626;
      `
      errorMsg.textContent = 'Bitte wählen Sie nur PDF-Dateien aus.'
      messagesArea.appendChild(errorMsg)
      messagesArea.scrollTop = messagesArea.scrollHeight
      setTimeout(() => errorMsg.remove(), 3000)
      return
    }

    // Check file size limit (10MB per file)
    const maxFileSize = 10 * 1024 * 1024 // 10MB
    const oversizedFiles = pdfFiles.filter((file) => file.size > maxFileSize)

    if (oversizedFiles.length > 0) {
      const errorMsg = document.createElement('div')
      errorMsg.style.cssText = `
        background: #fef2f2;
        color: #dc2626;
        padding: 8px 12px;
        border-radius: 8px;
        margin-bottom: 8px;
        font-size: 12px;
        border-left: 3px solid #dc2626;
      `
      errorMsg.textContent = `Datei(en) zu groß: ${oversizedFiles.map((f) => f.name).join(', ')}. Maximale Größe: 10MB pro Datei.`
      messagesArea.appendChild(errorMsg)
      messagesArea.scrollTop = messagesArea.scrollHeight
      setTimeout(() => errorMsg.remove(), 5000)
      return
    }

    // Show uploaded files
    pdfFiles.forEach((file) => {
      const fileMsg = document.createElement('div')
      fileMsg.style.cssText = `
        background: #f0f9ff;
        color: #0369a1;
        padding: 8px 12px;
        border-radius: 8px;
        margin-bottom: 8px;
        font-size: 12px;
        border-left: 3px solid #0369a1;
        display: flex;
        align-items: center;
        gap: 8px;
      `
      fileMsg.innerHTML = `
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke="currentColor" stroke-width="2" fill="none"/>
          <polyline points="14,2 14,8 20,8" stroke="currentColor" stroke-width="2" fill="none"/>
        </svg>
        <span>${file.name} (${(file.size / 1024 / 1024).toFixed(1)} MB)</span>
      `
      messagesArea.appendChild(fileMsg)
    })
    messagesArea.scrollTop = messagesArea.scrollHeight

    // Store files for context
    if (!window.uploadedPDFs) {
      window.uploadedPDFs = []
    }
    window.uploadedPDFs.push(...pdfFiles)

    // Update upload button appearance to show files are uploaded
    updateUploadButtonState()

    // Show success message
    const successMsg = document.createElement('div')
    successMsg.style.cssText = `
      background: #f0fdf4;
      color: #166534;
      padding: 8px 12px;
      border-radius: 8px;
      margin-bottom: 8px;
      font-size: 12px;
      border-left: 3px solid #16a34a;
    `
    successMsg.textContent = `${pdfFiles.length} PDF-Datei(en) erfolgreich hochgeladen. Sie können jetzt Fragen dazu stellen.`
    messagesArea.appendChild(successMsg)
    messagesArea.scrollTop = messagesArea.scrollHeight
    setTimeout(() => successMsg.remove(), 4000)
  }

  // Function to update upload button state
  const updateUploadButtonState = () => {
    const hasFiles = window.uploadedPDFs && window.uploadedPDFs.length > 0
    if (hasFiles) {
      uploadBtn.style.background = '#dbeafe'
      uploadBtn.style.color = '#1d4ed8'
      uploadBtn.style.borderColor = '#3b82f6'
      uploadBtn.innerHTML = `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke="currentColor" stroke-width="2" fill="none"/>
          <polyline points="14,2 14,8 20,8" stroke="currentColor" stroke-width="2" fill="none"/>
          <circle cx="12" cy="12" r="3" fill="currentColor"/>
        </svg>
      `
    } else {
      uploadBtn.style.background = '#f3f4f6'
      uploadBtn.style.color = '#6b7280'
      uploadBtn.style.borderColor = '#d1d5db'
      uploadBtn.innerHTML = `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke="currentColor" stroke-width="2" fill="none"/>
          <polyline points="14,2 14,8 20,8" stroke="currentColor" stroke-width="2" fill="none"/>
          <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" stroke-width="2"/>
          <line x1="12" y1="9" x2="12" y2="17" stroke="currentColor" stroke-width="2"/>
        </svg>
      `
    }
  }

  uploadBtn.onclick = () => fileInput.click()
  fileInput.onchange = (e) => handleFileUpload(e.target.files)

  // Add drag and drop support to the chat container
  chatContainer.ondragover = (e) => {
    e.preventDefault()
    chatContainer.style.border = '2px dashed rgb(41, 128, 185)'
    chatContainer.style.backgroundColor = '#f0f9ff'
  }

  chatContainer.ondragleave = (e) => {
    e.preventDefault()
    chatContainer.style.border = '1px solid #e5e7eb'
    chatContainer.style.backgroundColor = 'white'
  }

  chatContainer.ondrop = (e) => {
    e.preventDefault()
    chatContainer.style.border = '1px solid #e5e7eb'
    chatContainer.style.backgroundColor = 'white'
    handleFileUpload(e.dataTransfer.files)
  }

  const input = document.createElement('textarea')
  input.placeholder = 'Nachricht eingeben...'
  input.style.cssText = `
    flex: 1;
    padding: 14px 18px;
    border: none;
    border-radius: 24px;
    background: #f8fafc;
    font-size: 15px;
    color: #374151;
    outline: none;
    box-shadow: none;
  `
  input.onfocus = () => (input.style.borderColor = 'rgb(41, 128, 185)')
  input.onblur = () => (input.style.borderColor = '#d1d5db')

  const sendBtn = document.createElement('button')
  sendBtn.innerHTML = `
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" fill="currentColor"/>
    </svg>
  `
  sendBtn.style.cssText = `
    width: 44px;
    height: 44px;
    background: #2980b9;
    color: #fff;
    border: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    box-shadow: 0 2px 8px rgba(41,128,185,0.12);
    cursor: pointer;
    transition: background 0.2s, box-shadow 0.2s;
  `
  sendBtn.onmouseover = () => {
    sendBtn.style.background = '#21618c'
    sendBtn.style.boxShadow = '0 4px 16px rgba(41,128,185,0.18)'
  }
  sendBtn.onmouseout = () => {
    sendBtn.style.background = '#2980b9'
    sendBtn.style.boxShadow = '0 2px 8px rgba(41,128,185,0.12)'
  }

  // Send message handler
  const sendMessage = async () => {
    const message = input.value.trim()
    if (!message) return

    // Add user message
    const userMsg = document.createElement('div')
    userMsg.style.cssText = `
      background: rgb(41, 128, 185);
      color: white;
      padding: 10px 14px;
      border-radius: 16px;
      margin-bottom: 12px;
      margin-left: 40px;
      align-self: flex-end;
      max-width: 80%;
      word-wrap: break-word;
    `
    userMsg.innerHTML = `
      <div style="font-size: 13px; line-height: 1.4;">${message}</div>
    `
    messagesArea.appendChild(userMsg)

    // Clear input
    input.value = ''

    // Scroll to bottom
    messagesArea.scrollTop = messagesArea.scrollHeight

    // Call AI API using fetch with streaming
    const aiResponse = document.createElement('div')
    aiResponse.style.cssText = `
      background: white;
      padding: 10px 14px;
      border-radius: 16px;
      margin-bottom: 12px;
      border-left: 3px solid rgb(41, 128, 185);
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      max-width: 80%;
      word-wrap: break-word;
    `
    aiResponse.innerHTML = `
      <div style="font-weight: 500; color: #374151; margin-bottom: 4px; font-size: 12px;">AI Assistent</div>
      <div style="color: #6b7280; font-size: 13px; line-height: 1.4;">
        <span class="typing-indicator">
          <div style="display: inline-block; width: 12px; height: 12px; border: 2px solid #e5e7eb; border-top: 2px solid rgb(41, 128, 185); border-radius: 50%; animation: spin 1s linear infinite;"></div>
        </span>
      </div>
    `
    messagesArea.appendChild(aiResponse)
    messagesArea.scrollTop = messagesArea.scrollHeight

    // Get current page context
    const context = {
      url: window.location.href,
      title: document.title,
      pathname: window.location.pathname,
    }

    // Prepare form data with files
    const formData = new FormData()
    formData.append('message', message)
    formData.append('context', JSON.stringify(context))

    // Add uploaded PDFs if any
    if (window.uploadedPDFs && window.uploadedPDFs.length > 0) {
      window.uploadedPDFs.forEach((file, index) => {
        formData.append(`pdf_${index}`, file)
      })
      formData.append('pdf_count', window.uploadedPDFs.length.toString())
    } else {
      console.log('No PDFs to send')
    }

    try {
      const response = await fetch('/api/ai/chat', {
        method: 'POST',
        body: formData,
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      // Handle Vercel AI SDK streaming format
      const reader = response.body.getReader()
      const decoder = new TextDecoder()
      let responseText = ''

      while (true) {
        const { done, value } = await reader.read()
        if (done) break

        const chunk = decoder.decode(value)

        const lines = chunk.split('\n')

        for (const line of lines) {
          // Handle Vercel AI SDK streaming format: 0:"text"
          if (line.match(/^\d+:"/)) {
            const match = line.match(/^\d+:"(.+)"$/)
            if (match) {
              const text = match[1]
              responseText += text
              aiResponse.querySelector('.typing-indicator').innerHTML =
                parseMarkdown(responseText)
              messagesArea.scrollTop = messagesArea.scrollHeight
            }
          }
          // Handle end of stream
          else if (line.startsWith('d:') || line.startsWith('e:')) {
            break
          }
        }
      }
    } catch (error) {
      console.error('AI API Error:', error)
      aiResponse.querySelector('.typing-indicator').innerHTML =
        'Entschuldigung, es gab einen Fehler bei der Verarbeitung Ihrer Anfrage. Bitte versuchen Sie es später erneut.'
    }
  }

  sendBtn.onclick = sendMessage

  // Handle Enter key
  input.onkeydown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      sendMessage()
    }
  }

  inputContainer.appendChild(uploadBtn)
  inputContainer.appendChild(input)
  inputContainer.appendChild(sendBtn)
  inputArea.appendChild(inputContainer)
  inputArea.appendChild(fileInput)

  // Assemble chat
  chatContainer.appendChild(header)
  chatContainer.appendChild(messagesArea)
  chatContainer.appendChild(inputArea)

  // Add to page with null check
  if (document.body) {
    document.body.appendChild(chatContainer)
  } else {
    console.error('Document body not found, cannot append AI chat')
  }

  // Focus input
  setTimeout(() => input.focus(), 100)
}

// Temporarily off: widget has almost no page context and the stream UI is broken.
const AI_CHAT_WIDGET_ENABLED = false

const authData = JSON.parse(localStorage.auth)
const tokenPayload = JSON.parse(atob(authData.token.split('.')[1]))
const shouldShowAI =
  AI_CHAT_WIDGET_ENABLED && tokenPayload.tokenType !== 'ACCESS_TOKEN'

const initAIAgentWidget = () => {
  if (shouldShowAI) {
    // Wait for DOM to be fully ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(createAIAgentWidget, 100)
      })
    } else {
      // If DOM is already loaded, wait a bit to ensure everything is ready
      setTimeout(createAIAgentWidget, 100)
    }
  }
}

// Initialize with delay to ensure DOM is ready
setTimeout(initAIAgentWidget, 500)

// Expose function globally for manual testing
window.manualCreateAIAgentWidget = createAIAgentWidget
